export const NOTIFICATION_TYPES = {
  VISIT_CANCELLED_BY_OTHER: 'VISIT_CANCELLED_BY_OTHER',
  VISIT_COMPLETED_BY_OTHER: 'VISIT_COMPLETED_BY_OTHER',
  VISIT_STATUS_CHANGED_BY_OTHER: 'VISIT_STATUS_CHANGED_BY_OTHER',
  PAYMENT_FROM_REPRESENTATIVE: 'PAYMENT_FROM_REPRESENTATIVE',
} as const;

export type NotificationType = typeof NOTIFICATION_TYPES[keyof typeof NOTIFICATION_TYPES];

export interface VisitNotificationPayload {
  visitId: string;
  clientId: number;
  clientName: string;
  actorName: string;
  oldStatus?: string;
  newStatus?: string;
}

export interface PaymentNotificationPayload {
  payerName: string;
  amount: string;
  payerInn: string;
  paymentDate: string;
  paymentPurpose: string;
  paymentUniqueId?: string;
}

export type NotificationPayload = VisitNotificationPayload | PaymentNotificationPayload;

export function formatNotificationMessage(type: NotificationType, payload: NotificationPayload): string {
  switch (type) {
    case 'VISIT_CANCELLED_BY_OTHER': {
      const p = payload as VisitNotificationPayload;
      return `${p.actorName} отменил(а) визит к ${p.clientName}`;
    }
    case 'VISIT_COMPLETED_BY_OTHER': {
      const p = payload as VisitNotificationPayload;
      return `${p.actorName} выполнил(а) визит к ${p.clientName}`;
    }
    case 'VISIT_STATUS_CHANGED_BY_OTHER': {
      const p = payload as VisitNotificationPayload;
      return `${p.actorName} изменил(а) статус визита к ${p.clientName}`;
    }
    case 'PAYMENT_FROM_REPRESENTATIVE': {
      const p = payload as PaymentNotificationPayload;
      return `Платёж от представителя: ${p.payerName} — ${p.amount} руб. (УНП: ${p.payerInn})`;
    }
  }
}

export interface EmployeeNotificationDTO {
  id: string;
  type: NotificationType;
  payload: NotificationPayload;
  actorName: string | null; // null для системных нотификаций
  read: boolean;
  createdAt: string;
  requiresAcknowledgment: boolean;
  acknowledgedAt: string | null;
}
